/**
 * Variant URL Handler
 *
 * Two cases on product page load:
 *
 * 1. No ?variant= in URL (fresh visit):
 *    Liquid renders radio buttons unchecked, add-to-cart disabled, and shows
 *    a "From €X" price. theme.js updateCartButton handles swapping to the
 *    specific price once the user picks a valid variant combination.
 *
 * 2. ?variant= in URL (QR code / direct link):
 *    Liquid pre-renders the page fully for that variant — radio buttons
 *    checked, correct price shown, add-to-cart enabled. The carousel starts
 *    at the model slide via the starting-slide class (set in theme.js
 *    initProductSlider). Nothing extra needed.
 */

const VariantURLHandler = (function() {
  return {};
})();
